import React,{useContext, useEffect, useState} from 'react';
import MainMenu from './../../../components/mainMenu/MainMenu';
import LeftSitebarMenu from './../../../components/leftSitebarMenu/LeftSitebarMenu';
import RightSitebarMenu from './../../../components/rightSitebarMenu/RightSitebarMenu';
import closerIcon from '../../../assets/img/feed-imgs/navbar/closeicon.svg';
import { ShowHideSitebar } from './../../../App';
import bdLike from '../../../assets/img/blog-details-imgs/icons/bd-like-icon.svg';
import bdChat from '../../../assets/img/blog-details-imgs/icons/bd-chat-icon.svg';
import bdShare from '../../../assets/img/blog-details-imgs/icons/bd-share-icon.svg';
import postThumbnail from '../../../assets/img/blog-details-imgs/bd-postimg.png';
import roundedCircle from '../../../assets/img/blog-details-imgs/bd-userimg.png'
import './BlogDetails.css';
import {getBlogDatas as getBlogDatasApi} from '../../../api';
import { useParams } from 'react-router-dom';

const BlogDetails = () => {
    const param = useParams()
    const [ blogDetails, setBlogDetails ] = useState([])
    const [showHideSidebar, setShowHideSidebar] = useContext(ShowHideSitebar)
    useEffect(()=>{ /** setting the page name for the sidebars of this page to work */
        const setPageName = {...showHideSidebar}
        setPageName.pageName = 'blogs';
        setPageName.blogs.left = false;
        setPageName.blogs.right = false;
        setShowHideSidebar(setPageName)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    const closeSidebar =(whichSidebar, status)=>{
        const newStatus = {...showHideSidebar}
        if(whichSidebar === 'left'){
            newStatus.blogs.left = status /** changing the page name for left sidebar to toggle */
            setShowHideSidebar(newStatus) /** changing the page name for right sidebar to toggle */
        }
        if(whichSidebar === 'right'){
            newStatus.blogs.right = status
            setShowHideSidebar(newStatus)
        }
    }
    // Fetch Blog Data using Fake Data base 
    useEffect( ()=>{
        getBlogDatasApi().then(  
            data => setBlogDetails(data[Number(param.id)])
        )
    }, [param])
    // console.log("blogDetails Datas willbe here",blogDetails,typeof Number(param.id),Number(param.id), parseInt(param))
    console.log(blogDetails)
    return (
        <div>
            <MainMenu></MainMenu>
            {/* Menu bar start here */}
            <div className="container-fluid container-xxl">
                <div className="row gap-5 gap-lg-0">
                    {/* Left Site Bar Start here */}
                    <div className={`col-12 col-lg-2  d-lg-block ${showHideSidebar?.blogs?.left ? 'd-block right-sitebarmenu' : 'd-none'}`}>
                        <div className="d-flex d-lg-none justify-content-end mb-3">
                            <div onClick={()=>closeSidebar("left", false)} className="d-flex justify-content-center align-items-center action-button rounded-circle shadow-sm p-2 m-3" style={{ height: "32px", width: "32px"}}>
                                <img src={closerIcon} alt="" className='close-menu-button' />
                            </div>
                        </div>
                        <LeftSitebarMenu></LeftSitebarMenu>
                    </div>    
                    {/* left Site Bar End Hre */}

                    {/* Center Align Items Code start Here*/}
                    <div className="col-12 col-lg-10">
                        <div className="row mt-5 pt-4 mb-4 gap-3 gap-lg-0">
                            <div className="col-12">
                                <span className="bd_dm">
                                    {blogDetails.dateOfBlogPost}
                                </span>
                            </div>
                            <div className="col-12 mb-2">
                                <span className="bd_h">
                                    {blogDetails.blogTitle}
                                </span>
                            </div>
                            <div className="col-12 d-flex justify-content-start align-items-center gap-2 mb-4">
                                {
                                    //  <span className="txt_wa" key={index}>{console.log}</span>
                                    blogDetails?.blogTags?.map(( item, index ) =>  <div className="rounded-pill d-flex justify-content-center align-items-center bd_tags" key={index}>
                                        <span className="txt_wa"> {item}</span>
                                    </div> )
                                }
                            </div>
                            <div className="col-12 mb-4 d-flex justify-content-start align-items-center gap-2">
                                <img className="rounded-circle" src={blogDetails.authorImage} alt='' />
                                    <span className="bd_username">
                                        {blogDetails.name}
                                    </span>
                            </div>
                            <div className="col-12 mb-5">
                                <img className="w-100" src={blogDetails.postThumbnail} alt='' />
                            </div>
                            <div className="col-11 mb-4">
                                <h1 className="bd_h2">
                                    {blogDetails.thumbnailDescription}
                                </h1>
                            </div>
                            <div className="col-11 mb-5">
                                <p className="db_para" style={{lineHeight:" 45px"}}>
                                    {blogDetails.blogFistPara} <br /><br />{blogDetails.blogSecondPara}
                                </p>
                            </div>
                            <div className="col-12 mb-3">
                                <div className="row">
                                    <div className="col-11">
                                        <ul>
                                            { blogDetails?.bulletePoints?.map( (item,index) =>  <li className="mb-4 ps-0 ps-lg-5 db_para" key={index}> {item}
                                        </li> )  }
                                        </ul>
                                    </div>
                                    <div className="col-1"></div>
                                </div>
                            </div>
                            <div className="col-12 mb-5">
                                <div style={{backgroundColor: "#3B3B3B", height: "1px"}}></div>
                            </div>
                            <div className="col d-flex justify-content-start align-items-center gap-5">
                                <div>
                                    <img className="me-3" src={bdLike} alt='' />
                                    <span className='action-button'>{blogDetails.heartRate}</span></div>
                                <div>
                                    <img className="me-3" src={bdChat} alt='' />
                                        <span className='action-button'>{blogDetails.massages}</span>
                                </div>
                                <div>
                                    <img className="me-3" src={bdShare} alt='' /><span className='action-button'>{blogDetails.sharignPeople}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div className={`col-12 col-lg-4  d-none-lg ${showHideSidebar?.blogs?.right ? 'd-blog right-sitebarmenu' : 'd-none'}`}>
                    <div className="d-flex d-lg-none justify-content-end my-2">
                        <div onClick={()=>closeSidebar("right", false)} className="d-flex justify-content-center align-items-center action-button rounded-circle shadow-sm p-2 m-3" style={{ height: "32px", width: "32px"}}>
                                <img src={closerIcon} alt="" className='close-menu-button' />
                            </div>
                        </div>
                        <RightSitebarMenu />
                    </div>          
                </div>
            </div>
        </div>
    );
};

export default BlogDetails;